import React from "react";
import { Field, type Validator, type WrappedFieldProps } from "redux-form";

export interface ValidationProps {
  inputID: string;
  validate?: Validator | Validator[];
}

export const Validation = (props: ValidationProps) => {
  return (
    <Field {...props} name={props.inputID} component={ValidationRenderer} />
  );
};

const ValidationRenderer = ({ meta: { error } }: WrappedFieldProps) => {
  return <> {error}</>;
};
